import React from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../components/BottomNav";

const LegalPage = ({ title, content }) => {
    const navigate = useNavigate();

    return (
        <div className="bg-theme-bg text-theme-text min-h-screen pb-24 font-sans">
            <div className="p-4 bg-theme-card border-b border-theme-border sticky top-0 z-50 flex items-center gap-4">
                <button 
                  onClick={() => navigate(-1)} 
                  className="w-10 h-10 flex items-center justify-center bg-zinc-800/50 rounded-xl border border-theme-border/50 text-theme-text transition-all active:scale-95"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
                <h2 className="font-bold text-lg uppercase tracking-widest">{title}</h2>
            </div>

            <div className="p-6 prose prose-invert max-w-none">
                <div className="bg-theme-card/50 border border-theme-border p-6 rounded-3xl shadow-xl space-y-6">
                    {content}
                </div>
            </div>

            <BottomNav />
        </div>
    );
};

export const Terms = () => {
    const content = (
        <div className="space-y-4 text-xs text-theme-text-sec leading-relaxed">
            <h3 className="text-theme-text font-bold text-sm">1. ELIGIBILITY</h3>
            <p>You must be at least 18 years of age to use WinroX11. Participation in paid contests is open only to persons currently residing in India.</p>
            
            <h3 className="text-theme-text font-bold text-sm">2. RESTRICTED STATES</h3>
            <p>Residents of the following states are NOT allowed to participate in paid contests: **Assam, Odisha, Sikkim, Nagaland, Andhra Pradesh, Telangana, Meghalaya**. Any person residing in these states who joins a paid contest by providing false information will be disqualified and their winnings forfeited.</p>
            
            <h3 className="text-theme-text font-bold text-sm">3. USER ACCOUNTS</h3>
            <p>Users are allowed to maintain only one active account. Multiple accounts for a single user will result in permanent suspension.</p>
            
            <h3 className="text-theme-text font-bold text-sm">4. PAYMENTS & WITHDRAWALS</h3>
            <p>All deposits and withdrawals are subject to verification. TDS (Tax Deducted at Source) of 30% will be applicable on net winnings as per Govt. of India regulations.</p>
            
            <h3 className="text-theme-text font-bold text-sm">5. GOVERNING LAW</h3>
            <p>These terms shall be governed by and interpreted in accordance with the laws of India. Any dispute shall be subject to the exclusive jurisdiction of the courts of India.</p>
        </div>
    );
    return <LegalPage title="Terms & Conditions" content={content} />;
};

export const Privacy = () => {
    const content = (
        <div className="space-y-4 text-xs text-theme-text-sec leading-relaxed">
            <h3 className="text-theme-text font-bold text-sm">1. INFORMATION COLLECTION</h3>
            <p>We collect your name, mobile number, and device identifiers (Device ID) to provide a secure and personalized experience.</p>
            
            <h3 className="text-theme-text font-bold text-sm">2. USE OF DATA</h3>
            <p>Your data is used for authentication, processing payments via Razorpay, and preventing fraud. We do not sell your personal information to third parties.</p>
            
            <h3 className="text-theme-text font-bold text-sm">3. DATA SECURITY</h3>
            <p>We implement robust security measures to protect your account and financial data. However, no electronic transmission is 100% secure.</p>
            
            <h3 className="text-theme-text font-bold text-sm">4. THIRD PARTY SERVICES</h3>
            <p>We use third-party APIs like Razorpay for payments and Cricbuzz for match data. These services have their own privacy policies.</p>
        </div>
    );
    return <LegalPage title="Privacy Policy" content={content} />;
};

export const FairPlay = () => {
    const content = (
        <div className="space-y-4 text-xs text-theme-text-sec leading-relaxed">
            <h3 className="text-theme-text font-bold text-sm">1. FAIR PLAY GUARANTEE</h3>
            <p>WinroX11 ensures that every player has an equal chance of winning based on their skill and knowledge of cricket.</p>
            
            <h3 className="text-theme-text font-bold text-sm">2. TRANSPARENCY</h3>
            <p>The point system is clearly defined and applied uniformly to all participants. Match results are based on official data provided by Cricbuzz APIs.</p>
            
            <h3 className="text-theme-text font-bold text-sm">3. ANTI-CHEATING</h3>
            <p>Any use of bots, automated scripts, or multiple accounts to gain an unfair advantage is strictly prohibited and will lead to an immediate ban.</p>
            
            <h3 className="text-theme-text font-bold text-sm">4. RESPONSIBLE PLAY</h3>
            <p>Fantasy sports should be played for fun. We encourage users to play responsibly and set limits on their spending.</p>
        </div>
    );
    return <LegalPage title="Fair Play Policy" content={content} />;
};
